import PropTypes from 'prop-types';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/main.css';
import Divider from './divider.js';
import AutoplaySlider from './autoplay-slider';

const Main = () => (
	<div style={{ display: 'flex' }}>
		<section className="services">
			<div className="headline testimonials__headline">
				<p className="headline__title">
					We are a drafting service based in the Greater Sacramento Area. If you need house plans for new
					construction or additions, Title 24 Energy Reports, or 3d or 2d conceptual renderings, don't
					hesitate to contact us. We're able to serve people in the{' '} <strong>Sacramento, Roseville, 
                    Rocklin, Elk Grove, Folsom, Granite Bay</strong> areas and beyond.
                    <br className="d-none d-md-block" />
				</p>
				<Divider />
			</div>
			<div className="testimonials__slider">
				<AutoplaySlider />
			</div>
		</section>
	</div>
);

Main.propTypes = {
	siteTitle: PropTypes.string
};

Main.defaultProps = {
	siteTitle: ``
};

export default Main;
